import React from "react";
import Meals from "../components/Meals/Meals";

const Home = () => {
  return (
    <React.Fragment>
      <Meals />
    </React.Fragment>
  );
};

export default Home;
